import { render } from "./index.vue?vue&type=template&id=4c8a2326"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4c8a2326&lang=scss&scope=true"
import "./index.vue?vue&type=style&index=1&id=4c8a2326&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/adQuestionsPop/index.vue'],['render',render],['__file',"index.vue"]])

export default __exports__